<!--
 * @Author: wuhao
 * @Date: 2020-03-25 21:00:54
 * @LastEditors: wuhao
 * @LastEditTime: 2021-09-16 15:21:30
 * @Description: 二次封装 el-dialog
 -->
<template>
  <el-dialog
    ref="dialog"
    v-el-drag-dialog="drag"
    :class="{ 'btn-center': btnCenter, 'iframe-dialog-container': url }"
    :visible.sync="mVisible"
    :fullscreen="innerFullscreen"
    :center="center"
    v-bind="$attrs"
    @closed="closed"
    @open="openDialog"
    v-on="$listeners"
  >
    <span slot="title" class="dialog-header">
      <slot v-if="$slots.title" name="title" />
      <span v-else>{{ title }}</span>
      <i
        v-if="showFullscreen"
        class="fullscreen-icon btn-hover"
        :class="innerFullscreen ? 'el-icon-minus' : 'el-icon-full-screen'"
        @click="toggleFullscreen"
      />
    </span>
    <slot />
    <iframe v-if="url && mVisible" id="iframeContain" name="iframeContain" seamless scrolling="yes" :src="url">
      您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
    </iframe>
    <span v-if="showFooter && btnList.length === 0" slot="footer" class="dialog-footer">
      <el-button :size="size" :loading="btnLoading" type="primary" @click="confirm">{{ confirmText }}</el-button>
      <el-button :size="size" @click="cancle">{{ cancleText }}</el-button>
    </span>
    <span v-if="btnList && btnList.length > 0" slot="footer" class="dialog-footer">
      <template v-for="(item, index) in btnList">
        <el-button
          v-if="isShow(item.show)"
          :key="index"
          :disabled="isDisabled(item.disabled)"
          :size="size || item.size || $ELEMENT.size"
          v-bind="item"
          @click="$emit(item.emit)"
        >
          {{ item.text }}
        </el-button>
      </template>
    </span>
  </el-dialog>
</template>

<script>
import { t } from '@/locale'
import elDragDialog from './directive/drag'

export default {
  name: 'ApexDialog',
  directives: { elDragDialog },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    // 按钮loading状态
    btnLoading: {
      type: Boolean,
      default: false
    },
    // 是否显示全屏icon
    showFullscreen: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    // 是否显示底部按钮
    showFooter: {
      type: Boolean,
      default: true
    },
    // cancle按钮文字
    cancleText: {
      type: String,
      default() {
        return t('common.cancel')
      }
    },
    // confirm按钮文字
    confirmText: {
      type: String,
      default() {
        return t('common.confirm')
      }
    },
    // 是否开启拖拽功能
    drag: {
      type: Boolean,
      default: true
    },
    // 底部按钮大小
    size: {
      type: String,
      default: 'small'
    },
    // 是否居中
    center: {
      type: Boolean,
      default: false
    },
    // 底部按钮是否居中
    btnCenter: {
      type: Boolean,
      default: true
    },
    // 底部按钮 list
    btnList: {
      type: Array,
      default: () => []
    },
    // iframe url 链接
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      innerFullscreen: false
    }
  },
  computed: {
    mVisible: {
      get() {
        return this.visible
      },
      set(show) {
        this.$emit('update:visible', show)
      }
    }
  },
  methods: {
    openDialog() {
      this.innerFullscreen = this.fullscreen || this.innerFullscreen
    },
    isShow(show = true, index, row) {
      if (typeof show === 'boolean') {
        return show
      } else if (typeof show === 'function') {
        return show(index, row)
      }
      return Boolean(show)
    },
    isDisabled(disabled = false, index, row) {
      if (typeof disabled === 'boolean') {
        return disabled
      } else if (typeof disabled === 'function') {
        return disabled(index, row)
      }
      return Boolean(disabled)
    },
    toggleFullscreen() {
      this.innerFullscreen = !this.innerFullscreen
      if (this.innerFullscreen) {
        // 修复拖拽导致的全屏错位问题
        this.$refs.dialog.$el.firstChild.style.top = 0
        this.$refs.dialog.$el.firstChild.style.left = 0
      }
      this.$emit('toggleFullscreen', this.innerFullscreen)
    },
    closed() {
      this.innerFullscreen = false
    },
    cancle() {
      this.mVisible = false
      this.$emit('cancle')
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}

</script>

<style lang='scss' scoped>
.btn-center {
  /deep/ .el-dialog {
    .el-dialog__footer {
      text-align: center;
    }
  }
}
/deep/ .el-dialog {
  margin-bottom: 0;
  .el-dialog__header {
    border-bottom: 1px solid #f7f7f7;
    .el-dialog__headerbtn {
      top: 22px;
    }
  }
}
.dialog-header {
  height: 100%;
  display: block;
  position: relative;
  .fullscreen-icon {
    position: absolute;
    top: 2px;
    right: 30px;
    color: #909399;
  }
}
.btn-hover {
  &:hover,
  &:active {
    color: #409eff;
    cursor: pointer;
  }
}
#iframeContain {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
.iframe-dialog-container {
    /deep/ .el-dialog {
      display: flex;
      flex-direction: column;
      position: absolute;
      margin-top: 0 !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%);
      min-height: 80%;
      &.is-fullscreen {
        top: 0 !important;
        left: 0 !important;
        transform: translate(0, 0);
      }
      .el-dialog__body {
        height: calc(100% - 50px);
        position: relative;
        flex: 1;
        overflow: hidden;
        #iframeContain {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          padding: 10px 25px 20px;
        }
      }
    }
  }
</style>
